module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "nist-nec--dataset-cover.3029938a.jpg";